/* src/app/modules/display/components/menus/menu-flipper/menu-flipper.component.scss */
.relative-menu {
  position: relative;
}
/*# sourceMappingURL=menu-flipper.component.css.map */
